import axios from 'axios';
import { API_URL } from '../../../components/Constants';

export function isFetchCanceled(error: unknown): boolean {
  return axios.isCancel(error);
}

export async function fetchData({ cancelToken, authorization, isAuthenticated, value }) {
  if (cancelToken.current) cancelToken.current.cancel('New request');
  cancelToken.current = axios.CancelToken.source();

  const response = await axios({
    url: `${API_URL}api/search`,
    method: 'get',
    params: {
      pattern: value,
      ...(!isAuthenticated && { skey: 'unauth' }),
    },
    headers: {
      'Content-Type': 'application/json',
      accept: 'application/json',
      Authorization: authorization,
    },
    cancelToken: cancelToken.current.token,
  });

  return response.data.payload;
}
